// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2704":"59988791","2714":"1c4840d6","4288":"59988791","5551":"81953b18","5676":"59988791","5860":"3ea5e626","8755":"59988791","9740":"59988791"}[chunkId] + ".chunk.css";
};